import React, {Component} from 'react';
//import ReactMapGL, { Marker, Popup }  from 'react-map-gl';
import { Map, TileLayer, Marker, Popup } from 'react-leaflet';
import classes from './leaf.module.css'
import InfoBox from './InfoBox';
import { Button } from 'react-bootstrap';
import Search from './Search';
//import Match from './Match';
import Modal from './Modal';
import L from 'leaflet';
import Routing from "./RoutingMachine";
//import { Row, Col, Grid, Container } from 'react-bootstrap';
import ErrorBoundary from '../ErrorBoundary/ErrorBoundary'
import MarkerClusterGroup from 'react-leaflet-markercluster';
//import classes from './mapbox-gl.css'
const my_data = require('../data/test.json');

class leaf extends Component {

    constructor(props) {
    super(props);
    this.state = {
      center: [40.7484,-73.9755],
      selectedLinkCenter: {},
      selectedLink:null,
      zoom:10,
      links: [],
      distanceLink: [],
      matches: [],
      prelimUserLocation:{},
      userLocation: {},
      searchInput: "",
      searchLink: [],
      showMatches: false,
      showInfo: false,
      isMapInit: false,
      loading: false
    };
  }
  

  componentDidMount() {

    this.prelimSetUserLocation();

    try {
      this.fetchData()  
    } catch (err) {
      console.log(err);
      this.setState({
        loading: false,
      });
    }
  
    
    //fetch('https://data.cityofnewyork.us/resource/s4kf-3yrf.json')
    //  .then(res=> res.json())
     // .then(res=> 
      //    //console.log(json)
      //    this.setState({links:res})
      //);

  }

  fetchData=()=>{
    console.log('fetching...')
    fetch('https://data.cityofnewyork.us/resource/s4kf-3yrf.json')
    .then(res=> res.json())
    .then(res=> 
        //console.log(json)
        this.setState({links:res, loading: true})
    );
  }

  reloadData=()=>{
    this.setState({loading:false})
    this.fetchData();
  }


  LoadingMessage=()=> {
    return (
      <div className={classes.splash_screen}>
          <h1 className={classes.message}>...</h1>
        <div className={classes.loader}></div>
      </div>
    );
  }



  prelimSetUserLocation = () => {
    navigator.geolocation.getCurrentPosition(position => {
      let setUserLocation = [position.coords.latitude, position.coords.longitude];
      this.setState({prelimUserLocation: setUserLocation});
   });
  }

  setUserLocation = () => {
    console.log("attempting to get user location ...")
    navigator.geolocation.getCurrentPosition(position => {
      
      let setUserLocation = [position.coords.latitude, position.coords.longitude];
      console.log('user is at', setUserLocation);
    
       this.setState({
         zoom: 15,
         userLocation: setUserLocation,
         center: setUserLocation
      });
   });
  }
  
      //calculate straight line distance from point to point
      getDistanceFromLatLonInKm = (lat1,lon1,lat2,lon2) => {
        const R = 6371; // Radius of the earth in km
        const dLat = this.deg2rad(lat2-lat1);  // deg2rad below
        const dLon = this.deg2rad(lon2-lon1); 
        const a = 
          Math.sin(dLat/2) * Math.sin(dLat/2) +
          Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) * 
          Math.sin(dLon/2) * Math.sin(dLon/2)
          ; 
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
        let d = R * c; // Distance in km
        d = d *  0.62137119223733;
        return `Approx ${d.toFixed(2)} miles away from your location`;
      }

      deg2rad = (deg) => {
        return deg * (Math.PI/180)
      }

      //function to select the link for the popup
      setSelectedLink = (e) => {
        //console.log('clicked')
        this.setState({selectedLink:e, showInfo:true})
      }
  
      //****************child functions */
  
      handleInputChange = (event) => {
        event.preventDefault()
        console.log(event.target.value)
        if (event.target.value.length === 0) {
          this.setState({searchInput: "", showMatches: false, matches: [] })
          return
      }
          this.setState({searchInput: event.target.value })
          this.updateMatches()  
      }
  
      handleSubmit = (event) => {
        event.preventDefault()
        this.displayMatches();
      }
  
      findMatches = (wordToMatch, my_obj) => {
          return my_obj.filter(place => {
          // here we need to figure out the matches
          const regex = new RegExp(wordToMatch, 'gi');
          //console.log(place.street_address.match(regex))
          return place.street_address.match(regex)
        });
      }
  
      updateMatches =() => {
        const matchArray = this.findMatches(this.state.searchInput, this.state.links);
        const newStateMatches = matchArray.map(place => {
          //console.log(place.street_address);
          return place 
        });
        this.setState({matches:newStateMatches})
        
      }
  
      alertClicked = address => {
        let arr = eval(address.target.value);
        console.log(arr[0])
        let newViewport = {
          height: "100vh",
          width: "100vw",
          latitude: arr[0],
          longitude: arr[1],
          zoom: 17
        }
        const newPosition = [arr[0],arr[1]]
        this.setState({searchLink: address,
                       center: newPosition,
                       zoom: 18,
                       matches: [],
                      searchInput:""});
      }

      markerClick = (feature) => {
        console.log('myLAt', feature.latitude)
        //feature.preventDefault();
        this.setState({
          center: [parseFloat(feature.latitude), parseFloat(feature.longitude)],
          selectedLinkCenter: [parseFloat(feature.latitude), parseFloat(feature.longitude)],
          zoom: [16],
          selectedLink:feature
        });
      };
  
      saveMap = map => {
        //this.setUserLocation()
        this.map = map;
      };

      clearRoute =() => {
        this.setState({isMapInit:false});
      }

     routeUser = () => {
        this.setUserLocation();
        console.log('start lat ',this.state.userLocation[0])
        console.log('start lon ',this.state.userLocation[1])
        console.log('selected link lat', this.state.selectedLinkCenter[0])
        console.log('selected link lon', this.state.selectedLinkCenter[1])
        this.setState({isMapInit:true});
      } 



  render() {
    //this.prelimSetUserLocation()
    
    const iconUser = new L.Icon({
      iconUrl: require('../assets/user_location.png'),
      iconRetinaUrl: require('../assets/user_location.png'),
      iconAnchor: null,
      popupAnchor: null,
      shadowUrl: null,
      shadowSize: null,
      shadowAnchor: null,
      iconSize: new L.Point(50, 50),
      className: classes.blinking
    });

    const myCustomColour = '#4dff4d'

    const markerHtmlStyles = `background-color: ${myCustomColour};`

    const iconSelected = new L.Icon({
      iconUrl: require('../assets/red_marker.png'),
      iconRetinaUrl: require('../assets/red_marker.png'),
      iconAnchor: null,
      popupAnchor: null,
      shadowUrl: null,
      shadowSize: null,
      shadowAnchor: null,
      iconSize: new L.Point(50, 50),
      iconColor: new L.divIcon({html: `<span style="${markerHtmlStyles}" />`}),
      className: 'leaflet-div-icon'
    });


    const markers = this.state.links.map((link) =>
    <Marker 
      position={[parseFloat(link.latitude), parseFloat(link.longitude)]}
      //icon={  }
      onClick={this.markerClick.bind(this,link)}>
      <Popup onClose={this.clearRoute.bind(this,link)} className={classes.popup}>
        <div style={{"textAlign": "left"}}>
        <span> 
              <h5 style={{"textAlign": "left"}}>{link.cb_link_id}</h5>
              <p style={{"textAlign": "left"}}><img src="https://img.icons8.com/metro/26/000000/worldwide-location.png"/>{` ${link.street_address}`}</p>
              <p style={{"textAlign": "left"}}><img src="https://img.icons8.com/material-outlined/24/000000/district-of-columbia.png"/>{`Community Board: ${link.community_board}`}</p>
              <p style={{"textAlign": "left"}}><img src="https://img.icons8.com/material-outlined/24/000000/district-of-columbia.png"/>{`Council District: ${link.council_district}`}</p>
              <p style={{"textAlign": "left"}}>{this.getDistanceFromLatLonInKm(
                  this.state.prelimUserLocation[0],
                  this.state.prelimUserLocation[1],
                  this.state.selectedLinkCenter[0],
                  this.state.selectedLinkCenter[1]
              )}</p>
              
        </span>
        </div>
      </Popup>
    </Marker>
          );

    //styles
    const modalWrapper = {
      position: "absolute",
      bottom: "13%",
      width: "100%",
      zIndex: "1000",
      marginLeft: "85%"
    }

    const buttonWrapper ={
      position: "absolute",
      bottom: "5%",
      width: "100%",
      zIndex: "1000",
      marginLeft: "85%"
    }

    const userBtnStyle = {
      //position: "absolute",
      display:"block",
      backgroundColor:"white",
      borderRadius: "50%",
      borderWidth: "thin",
      borderColor: "white",
      border: "1px solid",
      padding: "10px",
      boxShadow: "1px 1px 1px #888888"
    }

    const loadBtnStyle ={
      display:"block",
      backgroundColor:"white",
      borderRadius: "50%",
      borderWidth: "thin",
      borderColor: "white",
      border: "1px solid",
      padding: "10px",
      boxShadow: "1px 1px 1px #888888"
    }


    const mapStyles = {
      position: "relative",
      top: "0",
      bottom: "0",
      width: "100vw",
      height: "100vh"
    }

    //render matches to search bar 
    return (

      <div>

        <div>{!this.state.loading ? 
              this.LoadingMessage() : 
              <div></div>}</div>
      
        <Map
          maxZoom={18} 
          center={this.state.center} 
          zoom={this.state.zoom} 
          ref={this.saveMap}
          style={mapStyles}>
        <Search
          handleInputChange = {this.handleInputChange.bind(this)}
          matches = {this.state.matches}
          showMatches = {this.state.showMatches}
          myValue= {this.state.searchInput}
          alertClicked = {this.alertClicked}
        />
        <TileLayer
          attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"
        />
        
        <MarkerClusterGroup>
          {markers}
        </MarkerClusterGroup>
        {Object.keys(this.state.userLocation).length !== 0 ? (
              <Marker
               position={this.state.userLocation}
               icon={iconUser}
              >
              </Marker>
              ) : ( 
              <div></div>
            )}
        { this.state.selectedLink ? (
              <Marker
              position={this.state.center}
              //icon={iconSelected}
              />
            ) : ( 
            <div></div>
          )}
      </Map>
      <div style = {buttonWrapper}>
      <Button    
            style={userBtnStyle} 
            onClick={this.setUserLocation}>
            <img src="https://img.icons8.com/material-outlined/24/000000/location-off.png" alt = "location"/>
      </Button>
      <br></br>
      <Button
            style={loadBtnStyle}
            className={classes.rotate} 
            onClick={this.reloadData}
            >
              <img src="https://img.icons8.com/material/24/000000/reboot.png"></img>
      </Button>
      <br></br>
       <Modal />
      </div>
       
      </div>
    );
  }
}

export default leaf;


/**
 * <TileLayer
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url='http://{s}.tile.osm.org/{z}/{x}/{y}.png'
        />

      {this.state.isMapInit ? <ErrorBoundary><Routing map={this.map}
                                         selectedLinkLat={this.state.selectedLinkCenter[0]}
                                         selectedLinkLon={this.state.selectedLinkCenter[1]}
                                         userLocationLat={this.state.userLocation[0]}
                                         userLocationLon={this.state.userLocation[1]}
                                          /></ErrorBoundary>: <div></div>}


                                          <button onClick={this.routeUser} 
                      style={{
                        "display":"block",
                        "backgroundColor":"#99ccff",
                        "borderRadius": "50%",
                        "borderWidth": "thin",
                        "borderColor": "white",
                        "border": "1px solid",
                        "padding": "10px",
                        "boxShadow": "1px 1px 1px #888888"
                      }}>
              <img src="https://img.icons8.com/metro/26/000000/sorting-arrows-horizontal.png"/>
              </button>
              Directions

        */